import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import en from "./assets/translation/en/index";
import zh from "./assets/translation/mandarin";
export const languageList = [{ name: "English (EN)", key: 'en' }, { name: "Mandarian (ZH)", key: 'zh' }]

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // we init with resources
    resources: {
      en,
      zh,
    },
    fallbackLng: "en",
    debug: false,

    // have a common namespace used around the full app
    // ns: ["translations"],
    // defaultNS: "translations",

    // keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false
    }
  });


export default i18n;
